module.exports = __webpack_public_path__ + "7a06bec87869cb9da277a66563681a5d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-8.png
// module id = 2371
// module chunks = 0